<template>
  <div class="shop-message" v-if="message && message?.isActive">
    <div class="shop-message-content">
      <Icon name="comment" />
      <div>
        <h1 v-if="message.title">
          {{ message.title }}
        </h1>
        <p v-if="message.content" class="break-all">
          {{ message.content }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '@component/Icon.vue'
import { ShopMessageResourceDto } from '@/munio/api/data'

defineProps<{
  message?: ShopMessageResourceDto
}>()
</script>
